var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCcVisaElectronLogo = function SvgCcVisaElectronLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 32,
    viewBox: "0 0 50 32"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "t3rtw4gy9a",
    x1: "45.974%",
    x2: "54.877%",
    y1: "-2.458%",
    y2: "100.435%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#222357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#254AA5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1276.000000, -229.000000) translate(56.000000, 229.000000) translate(1112.000000, 0.000000) translate(108.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 32,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    fill: "url(#t3rtw4gy9a)",
    fillRule: "nonzero",
    transform: "translate(6.500000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.136 8.164c-.022-1.672 1.483-2.605 2.616-3.16 1.164-.568 1.555-.933 1.551-1.442-.009-.779-.929-1.123-1.79-1.136-1.502-.024-2.375.407-3.07.733l-.54-2.543C18.598.293 19.888.012 21.226 0c3.14 0 5.194 1.557 5.205 3.97.012 3.063-4.219 3.233-4.19 4.602.01.415.404.858 1.269.97.428.058 1.609.101 2.947-.518l.526 2.46c-.72.264-1.646.516-2.798.516-2.955 0-5.034-1.578-5.05-3.836m12.898 3.624c-.574 0-1.057-.336-1.273-.851L26.276.18h3.138l.624 1.733h3.834L34.235.18H37l-2.413 11.607h-2.553m.438-3.136l.906-4.358h-2.48l1.574 4.358m-17.14 3.136L12.857.181h2.99l2.472 11.607h-2.989m-4.423 0l-3.112-7.9-1.259 6.717c-.147.75-.73 1.183-1.378 1.183H.07L0 11.451c1.044-.228 2.231-.595 2.95-.988.44-.24.565-.45.71-1.02L6.044.182h3.16l4.844 11.607h-3.14",
    transform: "translate(18.500000, 6.000000) scale(-1, 1) rotate(-180.000000) translate(-18.500000, -6.000000)"
  })))))))));
};
export default SvgCcVisaElectronLogo;